import type { IntlShape } from 'react-intl'

import { maskAnonymisedContactValue } from 'Utilities'

import type { getEmployeeListPreviewColumn_employee } from 'Constants/graphql/queries/detail/__generated__/getEmployeeListPreviewColumn'

export const generateEmployeesPreviewColumnContent = (
  employee?: getEmployeeListPreviewColumn_employee,
  rentCategoryTierName?: string | null,
  intl?: IntlShape,
) => [
  {
    copyable: true,
    label: 'PreviewColumn_email',
    value: maskAnonymisedContactValue(
      employee?.contact.email,
      employee?.contact,
      intl,
    ),
  },
  {
    copyable: true,
    label: 'PreviewColumn_phone_number',
    value: maskAnonymisedContactValue(
      employee?.contact.phoneNumber,
      employee?.contact,
      intl,
    ),
  },
  {
    label: 'PreviewColumn_organisation',
    value: employee?.organisation?.fullName,
  },
  {
    label: 'PreviewColumn_office',
    value: employee?.office?.locationName,
  },
  {
    label: 'PreviewColumn_cost_center',
    value: employee?.costCenter?.name,
  },
  {
    copyable: true,
    label: 'PreviewColumn_employee_id',
    value: maskAnonymisedContactValue(
      employee?.externalReference,
      employee?.contact,
      intl,
    ),
  },
  {
    label: 'PreviewColumn_rent_category_tier',
    value: rentCategoryTierName,
  },
]
